var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('Top'),_c('main',{staticClass:"main-container",class:{ 'with-padding': _vm.needTopPadding }},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }